import { BigSearchBox } from "@components/controls/SearchBox"
import { StaggerTransitionRoot, Transition } from "@components/motion/Transition"
import { PageTitle } from "@components/page/PageTitle"
import { SidebarLayout } from "@components/page/SidebarLayout"
import { ContentBlocks } from "eddev/blocks"
import { useRoute, useSearchParams, useViewRoute } from "eddev/routing"
import { defineView } from "eddev/views"
import { AnimatePresence } from "framer-motion"
import { Fragment } from "react/jsx-runtime"

export const meta: ViewMeta = {
  templateName: "FAQ Listing",
}

export default defineView("template-faq-listing", (props) => {
  const route = useRoute()
  const slug = route.pathname.replace(/^\/faqs\//, "")

  const faqCategory = props.faqs?.nodes.find((faq) => faq.slug === slug)
  const [query, queryApi] = useSearchParams({
    q: "",
  })

  return (
    <SidebarLayout
      nav={{
        children: [
          { label: "Overview", url: "/faqs" },
          ...props.faqs?.nodes.map((faq) => ({
            label: faq?.title,
            url: `/faqs/${faq?.slug}`,
          }))!,
        ],
      }}
    >
      <AnimatePresence mode="wait">
        <StaggerTransitionRoot key={props.faq?.slug}>
          <div data-transition="fade">
            <PageTitle title="Frequently Asked Questions" subtitle={faqCategory?.title ?? "Overview"} />
          </div>

          {/* Intro section */}
          <ContentBlocks
            blocks={props.page?.contentBlocks}
            wrapBlock={(child, ctx) => {
              if (ctx.current.flags?.selfAnimates) {
                return child
              } else {
                return <div data-transition="children/fade">{child}</div>
              }
            }}
          />

          {/* Search box */}
          {/* <div className="mt-5 mb-8">
            <BigSearchBox placeholder="Search" onSearch={queryApi.setter("q")} />
          </div> */}

          {/* Results */}
          <div data-transition="children/fade" className="stack-y-5 mt-3 pb-8">
            {(faqCategory ? [faqCategory] : props.faqs?.nodes)?.map((faq) => (
              <Fragment key={faq.slug}>
                <ContentBlocks blocks={faq?.contentBlocks} />
              </Fragment>
            ))}
          </div>
        </StaggerTransitionRoot>
      </AnimatePresence>
    </SidebarLayout>
  )
})
